class LoadMore extends HTMLElement {
    constructor() {
        super();
        this.utils = new Utils()
        this.url = '{{ url }}';
        this.itemPerPage = parseInt('{{ perPage }}');
        this.button = this.querySelector('button');
        this.bufferedPage = {
            key: '',
            value: ''
        };

        this.setPageProperties();

        this.gridItemSelector = this.dataset.gridItem || 'li[data-product-item]';
        this.gridSelector = this.dataset.grid || '[data-product-grid]'
        this.gridElem = document.querySelector(this.gridSelector);
    }

    setPageProperties() {
        this.totalPages = this.getAttribute('data-total-pages');
    }

    connectedCallback() {
        this.dataset.itemPerPage = this.itemPerPage;
        this.handleCurrentPagination();
        this.listener();

        subscribe(PUB_SUB_EVENTS.facetsUpdate, () => {
            this.bufferedPage = {
              key: "",
              value: "",
            };
          });
          this.createBufferedPage(2);

        history.scrollRestoration = 'auto';
    }

    listener() {
        this.button?.addEventListener('click', async (e) => {
            this.handleAction()
        });

        window.addEventListener('scroll', () => {
            if ( this.utils.isElementVisible(this) && !this.classList.contains('tw-hidden')) {
                this.handleAction()
            }
        })
    }

    handleAction() {
        const url = new URL(location);
        const curPage = parseInt(url.searchParams.get('pagination')) || 1;
        url.searchParams.set('pagination', curPage + 1);
        history.pushState(null, null, url.toString());
        this.renderContent();
        this.createBufferedPage(curPage + 2);
    }


    async createBufferedPage(bufferPage) {
        const url = new URL(location);
        url.searchParams.set("page", bufferPage);
        const response = await fetch(url);
        this.bufferedPage.key = bufferPage;
        this.bufferedPage.value = await response.text();
      }

    getCurrentPage() {
        const url = new URL(window.location);
        return parseInt(url.searchParams.get('pagination'));
    }

    async handleCurrentPagination() {
        try {
            this.parentElement.toggleAttribute('loading', !0);
            const page = this.getCurrentPage();
            if (page) {
                for (let i = 2; i <= page; i++) {
                    const url = new URL(window.location);
                    url.searchParams.set('pagination', parseInt(i));
                    history.pushState(null, null, url.toString());
                    await this.renderContent();
                }
            }

            const url = new URL(window.location);
            this.createBufferedPage(parseInt(url.searchParams.get('pagination') || 1) + 1);

        } catch (err) {
            return this.parentElement.toggleAttribute('loading', !1), !1;
        }
    }

    async renderContent() {
        this.classList.add('tw-hidden');
        this.parentElement?.classList.add('loading');

        const page = this.getCurrentPage();

     
        let html;

        if (this.bufferedPage.key === page) {
            html = this.bufferedPage.value;
        } else {
            const response = await fetch(
                window.location.href.replace("pagination", "page")
              );
              html = await response.text();
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = document.createDocumentFragment();

        const newGridItems = doc.querySelectorAll(this.gridSelector + ' ' + this.gridItemSelector);

        newGridItems.forEach(item => {
            fragment.appendChild(item);
        });

        this.gridElem.appendChild(fragment);

        this.classList.toggle('tw-hidden', page >= parseInt(this.totalPages))

        this.setPageProperties();
        this.parentElement?.classList.remove('loading');

    }
}

customElements.define('load-more', LoadMore);
